import React, { useState } from 'react';
import './V1FAQSection.css';

interface V1FAQSectionProps {
  theme: 'premium' | 'energetic';
}

const V1FAQSection: React.FC<V1FAQSectionProps> = ({ theme }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: 'Czy to naprawdę działa?', a: 'Tak! 98% naszych uczniów zdaje egzaminy powyżej swoich oczekiwań. Mamy sprawdzoną metodykę i setki success stories.' },
    { q: 'Co jeśli nie zdążę?', a: 'Nasz 8-tygodniowy program jest zaprojektowany tak, aby dać Ci wszystkie narzędzia potrzebne do sukcesu, nawet przy późnym starcie.' },
    { q: 'Jak wygląda pierwsza lekcja?', a: 'Pierwsza lekcja to diagnostyka - poznajemy Twój poziom, cele i wspólnie tworzymy spersonalizowany plan nauki.' }
  ];

  return (
    <section className="v1-faq-section v1-section">
      <div className="v1-container">
        <h2 className="v1-section-title v1-animate-in">
          {theme === 'premium' ? 'Najczęściej Zadawane Pytania' : '❓ FAQ'}
        </h2>

        <div className="v1-faq-list">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`v1-faq-item v1-glass ${openIndex === index ? 'open' : ''}`}
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <div className="v1-faq-question">
                <h3>{faq.q}</h3>
                <span className="v1-faq-toggle">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="v1-faq-answer">
                  <p>{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default V1FAQSection;
